interface NavAttributes {
  [propName: string]: any;
}
interface NavWrapper {
  attributes: NavAttributes;
  element: string;
}
interface NavBadge {
  text: string;
  variant: string;
}
interface NavLabel {
  class?: string;
  variant: string;
}

export interface NavData {
  name?: string;
  url?: string;
  icon?: string;
  badge?: NavBadge;
  title?: boolean;
  children?: NavData[];
  variant?: string;
  attributes?: NavAttributes;
  divider?: boolean;
  class?: string;
  label?: NavLabel;
  wrapper?: NavWrapper;
}

export const navItems: NavData[] = [
  {
    name: 'Run Management',
    url: '/run-management',
    icon: 'icon-list',
  },

  {
    name: 'Audit Trail',
    url: '/audit-trail',
    icon: 'cui-circle-check',
  },
  {
    name: 'Taxpayer',
    url: '/taxpayer',
    icon: 'icon-wallet',
  },
  {
    name: 'Users',
    url: '/users',
    icon: 'icon-people',
  },
];
